import { memo, useContext } from 'react'
import { T } from 'consts/translationKeys'
import { TtsItemSpeakerFlyoutContext } from '../contextApi'

import { translate } from 'utils/translations'
import { Text } from 'common-components'
import * as Styled from './styled'
import TtsItemVoiceToneContainer from './Tone'
import TtsItemLanguageDropdown from './Language'
import TtsItemSpeakerDropdown from './Speaker'

const TtsItemSpeakerFlyoutContentRowItem = ({
  label,
  children
}: {
  label: string
  children: React.ReactNode
}) => {
  return (
    <Styled.TtsItemSpeakerContentRowWrapper>
      <Text type="h4" color="secondary" fontWeight="600">
        {label}
      </Text>
      {children}
    </Styled.TtsItemSpeakerContentRowWrapper>
  )
}

export const TtsItemSpeakerFlyoutContent: React.FC = () => {
  const { hasEmotion } = useContext(TtsItemSpeakerFlyoutContext)

  return (
    <Styled.TtsItemSpeakerContainer>
      <Text type="h2" color="secondarySemiDark" fontWeight="700">
        {translate(T.CHANGE_SPEAKER)}
      </Text>
      <TtsItemSpeakerFlyoutContentRowItem label={translate(T.LANGUAGE_LABEL)}>
        <TtsItemLanguageDropdown />
      </TtsItemSpeakerFlyoutContentRowItem>
      <TtsItemSpeakerFlyoutContentRowItem label={translate(T.VOICE)}>
        <TtsItemSpeakerDropdown />
      </TtsItemSpeakerFlyoutContentRowItem>
      {hasEmotion && (
        <TtsItemSpeakerFlyoutContentRowItem label={translate(T.TTS_VOICE_TONE)}>
          <TtsItemVoiceToneContainer />
        </TtsItemSpeakerFlyoutContentRowItem>
      )}
    </Styled.TtsItemSpeakerContainer>
  )
}

export default memo(TtsItemSpeakerFlyoutContent)
